import { render, staticRenderFns } from "./ViewWorkplacePage.vue?vue&type=template&id=7420e383&"
import script from "./ViewWorkplacePage.vue?vue&type=script&lang=js&"
export * from "./ViewWorkplacePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports